module.exports = __webpack_public_path__ + "static/media/badPackaging2.c4076d77.png";